import { fromJS } from 'immutable';
import { types } from './actions';
import { Types as signInActionTypes } from './containers/Authentication/SignIn/actions';
import { ROUTES } from '@shared/constants';
import { ROLES } from '@shared/constants/roles';
import {
  setToLocalStorage,
  LOCAL_STORAGE_ITEM,
  removeFromLocalStorage,
  removeCognitoIdentityServiceProviderItems,
} from '../../utils/localStorageHelper';

export const initialState = fromJS({
  authentication: {
    validating: false,
    user: {},
    token: null,
  },
  videoChatV2InMeeting: false,
  theme: 'novotalks',
  userRoles: {},
  serverProperties: {
    loading: false,
    properties: [],
  },
  error:''
});

const rolesHelper = (roles) => {
  if (!roles || !roles.length) {
    return ROUTES.COURSE_PAGE;
  }
  const role = roles[0];
  if (!role) {
    return ROUTES.COURSE_PAGE;
  }
  switch (role) {
    case ROLES.CLINICAL_MENTOR_HEB:
    case ROLES.EMOTIONAL_MENTOR_HEB:
    case ROLES.CLINICAL_MENTOR_EN:
    case ROLES.EMOTIONAL_MENTOR_EN:
    case ROLES.DEFAULT_MENTOR:
      return ROUTES.PENDING_DASHBOARD;
    case ROLES.MANAGEMENT_ADMIN:
    case ROLES.SUPERVISOR:
    case ROLES.TECH_ADMIN:
      return ROUTES.USERS.LIST;
    default:
      return ROUTES.COURSE_PAGE;
  }
};

const saveUserToLocalStorage = (user) => {
  // patch until we get the default page from api
  user.defaultPage = rolesHelper(user.roles);
  setToLocalStorage(LOCAL_STORAGE_ITEM.USER, user);
};
const saveuserRolesToLocalStorage = (userRoles) => {
  setToLocalStorage(LOCAL_STORAGE_ITEM.USER_ROLES, userRoles);
};

const updateLocaleInLocalStorage = (locale) => {
  if (localStorage.user) {
    const user = JSON.parse(localStorage.user);
    user.locale = locale.toUpperCase();
    saveUserToLocalStorage(user);
  }
};

function appReducer(state = initialState, action) {
  switch (action.type) {
    case signInActionTypes.COGNITO_SIGN_IN_SUCCESS:
      setToLocalStorage(LOCAL_STORAGE_ITEM.TOKEN, action.payload);
      return state.setIn(['authentication', 'token'], action.payload);
    case signInActionTypes.SIGN_IN_SUCCESS:
      saveUserToLocalStorage(action.payload);
      const defaultPage = rolesHelper(action.payload.roles);
      return state
        .setIn(['authentication', 'user'], fromJS(action.payload))
        .setIn(['authentication', 'user', 'defaultPage'], defaultPage);
    case types.CHANGE_LOCALE:
      updateLocaleInLocalStorage(action.locale)
          return state.setIn(
              ['authentication', 'user', 'locale'],
              fromJS(action.locale),
          )
    case 'SET_THEME':
      return state.set('theme', action.theme);
    case types.CLEAR_TOKEN:
      const preserveCognitoNewPasswordChallenge = Boolean(
        action?.options?.preserveCognitoNewPasswordChallenge,
      );
      removeFromLocalStorage(LOCAL_STORAGE_ITEM.USER);
      removeFromLocalStorage(LOCAL_STORAGE_ITEM.TOKEN);
      if (!preserveCognitoNewPasswordChallenge) {
        removeFromLocalStorage(LOCAL_STORAGE_ITEM.COGNITO_NEW_PASSWORD_CHALLENGE);
      }
      removeFromLocalStorage(LOCAL_STORAGE_ITEM.COGNITO_LAST_CONFIRMATION_RESEND);
      removeCognitoIdentityServiceProviderItems();
      return state
        .setIn(['authentication', 'user'], fromJS({}))
        .setIn(['authentication', 'token'], null)
        .set('videoChatV2InMeeting', false);
    case types.SET_USER_ROLES:
      saveuserRolesToLocalStorage(action.userRoles);
      return state.set('userRoles', action.userRoles);
    case types.SET_APP_ERROR:
      return state.set('error', action.error)
    case types.SET_VIDEO_CHAT_V2_IN_MEETING:
      return state.set('videoChatV2InMeeting', Boolean(action.inMeeting));
    case types.GET_SERVER_PROPERTIES:
      return state.setIn(['serverProperties', 'loading'], true);
    case types.SET_SERVER_PROPERTIES:
      return state.set(
        'serverProperties',
        fromJS({
          properties: action.properties,
          loading: false,
        }),
      );
    default:
      return state;
  }
}

export default appReducer;
